import React from "react";
import { UIText } from "@pfs/react-ui-kit";
import { Button } from "@pc/ds-react";
import { useTranslation } from "src/hooks/useTranslation";
import { TEXT_TAGS } from "src/utils/enums";
import "./TransferToSiteModal.scss";

export interface TransferToSiteModalProps {
  userName?: string;
  siteName: string;
  siteLogo?: string;
  balanceFormatted: string;
  balanceLoading?: boolean;
  onConfirm: () => void;
  onClose?: () => void;
}

const TransferToSiteModal: React.FC<TransferToSiteModalProps> = ({
  userName,
  siteName,
  siteLogo,
  balanceFormatted,
  balanceLoading = false,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation();
  const displayName = userName?.trim() || t("payCardActivation.defaultName");

  return (
    <div className="transfer-to-site-modal">
      <div className="transfer-to-site-modal__header">
        <div className="transfer-to-site-modal__greeting">
          <UIText
            text={t("transferToSite.greeting", { name: displayName })}
            tag={TEXT_TAGS.H2}
            size={32}
            weight={400}
          />
        </div>
        {siteLogo ? (
          <div className="transfer-to-site-modal__logo">
            <img src={siteLogo} alt={siteName} className="transfer-to-site-modal__logo-img" />
          </div>
        ) : (
          <div className="transfer-to-site-modal__site-name">
            <UIText text={siteName} tag={TEXT_TAGS.H2} size={22} weight={700} />
          </div>
        )}
      </div>

      <div className="transfer-to-site-modal__balance-section">
        <UIText
          text={t("transferToSite.estimatedBalance")}
          tag={TEXT_TAGS.P}
          size={18}
          weight={400}
        />
        <div className="transfer-to-site-modal__balance-value" dir="ltr">
          {balanceLoading ? (
            <span className="transfer-to-site-modal__balance-spinner" />
          ) : (
            <UIText
              text={t("transferToSite.balanceUpTo", { amount: balanceFormatted })}
              tag={TEXT_TAGS.SPAN}
              size={42}
              weight={700}
            />
          )}
        </div>
        <p className="transfer-to-site-modal__terms-line">
          {t("transferToSite.termsPrefix")}{" "}
          <a
            href="#"
            className="transfer-to-site-modal__terms-link"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            {t("transferToSite.termsLink")}
          </a>
        </p>
      </div>

      <div className="transfer-to-site-modal__disclaimer-box">
        <UIText
          text={t("transferToSite.noteTitle")}
          tag={TEXT_TAGS.P}
          size={24}
          weight={600}
        />
        <UIText
          text={t("transferToSite.noteBody")}
          tag={TEXT_TAGS.P}
          size={24}
          weight={400}
        />
      </div>

      <div className="transfer-to-site-modal__actions">
        <Button
          onClick={onConfirm}
          variant="primary"
        >
          {t("transferToSite.confirmButton")}
        </Button>
      </div>
    </div>
  );
};

export default TransferToSiteModal;
